import React, { useEffect, useState } from 'react';

import AiManagementProposalCompany from 'components/molecules/ai_management_proposal_company';
import AiManagementProposalConditions from 'components/molecules/ai_management_proposal_conditions';
import { useProposalShell } from 'components/organisms/ai_management_bidding_proposal/context';

interface AiManagementProposalCompanyStepProps {
  biddingId: number;
}

// A casca guarda uma contagem por etapa: soma aqui empresa + condições. Até a empresa carregar,
// mantém a contagem do back; as condições contam 0 enquanto não carregam.
const AiManagementProposalCompanyStep: React.FC<AiManagementProposalCompanyStepProps> = ({
  biddingId,
}) => {
  const { setPendencies } = useProposalShell();
  const [empresa, setEmpresa] = useState<number | null>(null);
  const [condicoes, setCondicoes] = useState(0);
  const [faltaEmpresa, setFaltaEmpresa] = useState<string[]>([]);
  const [faltaCondicoes, setFaltaCondicoes] = useState<string[]>([]);
  const falta = [...faltaEmpresa, ...faltaCondicoes];

  useEffect(() => {
    if (empresa !== null) setPendencies('empresa', empresa + condicoes);
  }, [empresa, condicoes, setPendencies]);

  return (
    <>
      {falta.length > 0 && (
        <div className="alert alert-warning d-flex align-items-start" role="status">
          <i className="material-icons-outlined mr-2" aria-hidden="true">
            error_outline
          </i>
          <div>
            <strong>Para concluir esta etapa:</strong>
            <ul className="mb-0 mt-1 pl-3" style={{ listStyle: 'disc' }}>
              {falta.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      )}
      <AiManagementProposalCompany
        biddingId={biddingId}
        onPendencies={setEmpresa}
        onPendencyItems={setFaltaEmpresa}
      />
      <AiManagementProposalConditions
        biddingId={biddingId}
        onPendencies={setCondicoes}
        onPendencyItems={setFaltaCondicoes}
      />
    </>
  );
};

export default AiManagementProposalCompanyStep;
